import ErrorIcon from "@mui/icons-material/Error";
import React from "react";
import { ListStateIcon } from "../ListStateIcon/ListStateIcon";

interface IListStateIconErrorProps {
    tooltip: string
}

export const ListStateIconError = (props: IListStateIconErrorProps) => {
    return (
        <ListStateIcon
            tooltip={props.tooltip}
            icon={ErrorIcon}
            color="error"
        />
    );
};
